import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-363e08ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex flex-row md:flex-col sm:px-0 px-4 bg-red-0" }

import { ref, Ref, computed } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'BoardCategory',
  setup(__props) {

const store = useStore();
const activeMenu :Ref<String> = ref('free') 

const communityList = computed(()=> store.state.community)


const handleBtn = async (menuName :string) => {
    if (menuName === 'free') {
        activeMenu.value = menuName;
        if(communityList.value[1].data.length === 0){
            await store.dispatch('fetchCommData', 1);
        }
        store.commit('SET_CURRENT_COMMUNITY', store.state.community[1].data)
        // console.log('여펭 버튼 클릭',store.state.currentCommunityList)
    } 
    if( menuName === 'qa'){
        activeMenu.value = menuName;
        if(communityList.value[2].data.length === 0){
            await store.dispatch('fetchCommData', 2);
        }
        store.commit('SET_CURRENT_COMMUNITY', store.state.community[2].data)
    }
    if(menuName === 'photo') {
        activeMenu.value = menuName;
    }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/community" }, {
      default: _withCtx(() => [
        _createElementVNode("h3", {
          class: _normalizeClass(["btn",  activeMenu.value === 'free' ? 'bg-[#f9f9f9] ' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleBtn('free')))
        }, "💬 자유게시판", 2)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: "/qna" }, {
      default: _withCtx(() => [
        _createElementVNode("h3", {
          class: _normalizeClass(["btn",  activeMenu.value === 'qa' ? 'bg-[#f9f9f9] ' : '']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleBtn('qa')))
        }, "✋🏻 질문&답변", 2)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: "/gallery" }, {
      default: _withCtx(() => [
        _createElementVNode("h3", {
          class: _normalizeClass(["btn",  activeMenu.value === 'photo' ? 'bg-[#f9f9f9] ' : '']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleBtn('photo')))
        }, "📷  갤러리", 2)
      ]),
      _: 1
    })
  ]))
}
}

})